import { createTheme } from '@mui/material';

const customBreakpoints = {
  xs: 0,
  sm: 600,
  md: 768,
  lg: 1200,
  xl: 1600,
};

const theme = createTheme({
  breakpoints: {
    values: customBreakpoints,
  },
  typography: {
    fontFamily: 'Outfit, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    h1: {
      fontSize: 26,
      fontWeight: 600,
      lineHeight: 1.1,
      letterSpacing: "-0.8px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: { fontSize: 16 },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: { fontSize: 22 },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: { fontSize: 24 },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: { fontSize: 26 },
      [`@media (min-width:${customBreakpoints.xl}px)`]: { fontSize: 28 },
    },
    h2: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 1.15,
      letterSpacing: "-0.4px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: { fontSize: 12 },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: { fontSize: 16 },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: { fontSize: 18 },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: { fontSize: 20 },
      [`@media (min-width:${customBreakpoints.xl}px)`]: { fontSize: 22 },
    },
    h3: {
      fontSize: 22,
      fontWeight: 600,
      letterSpacing: '-0.2px',
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: { fontSize: 12 },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: { fontSize: 18 },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: { fontSize: 20 },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: { fontSize: 22 },
      [`@media (min-width:${customBreakpoints.xl}px)`]: { fontSize: 24 },
    },
    body_400: {
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: "0.28px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
    },
    body_500: {
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
    },
    body_600: {
      fontSize: 18,
      fontWeight: 600,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 20,
      },
    },
    body_700: {
      fontSize: 18,
      fontWeight: 700,
      letterSpacing: "0.36px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 20,
      },
    },
    subtitle_300: {
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
    },
    subtitle_400: {
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: "0.32px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 18,
      },
    },
    subtitle_500: {
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: "0.28px",
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    subtitle_600: {
      fontSize: 12,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    overline_400: {
      fontSize: 12,
      fontWeight: 400,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 10,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
    },
    overline_600: {
      fontSize: 14,
      fontWeight: 600,
      [`@media (min-width:${customBreakpoints.xs}px) and (max-width:${customBreakpoints.sm}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.sm}px) and (max-width:${customBreakpoints.md}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.md}px) and (max-width:${customBreakpoints.lg}px)`]: {
        fontSize: 12,
      },
      [`@media (min-width:${customBreakpoints.lg}px) and (max-width:${customBreakpoints.xl}px)`]: {
        fontSize: 14,
      },
      [`@media (min-width:${customBreakpoints.xl}px)`]: {
        fontSize: 16,
      },
    },
  },
  palette: {
    common: {
      black: "#000000",
      white: "#FFFFFF",
      red: "#c53030"
    },
    primary: {
      50: "#e9f4ff",
      100: "#fbe2d7",
      200: "#fbe2d7",
      main: "#a33d18",
      300: "#fbe2d7",
      500: "#a33d18",
      600: "#151515",
      800: "#114f8c",
      900: "#0d3c6b",
    },
    success: {
      50: "#e7faf2",
      100: "#b4efd8",
      500: "#057a4d",
      800: "#087047",
      900: "#065536"
    },
    error: {
      50: "#feecf0",
      100: "#fbc5d0",
      500: "#c9304f",
      800: "#852538",
      900: "#651c2b"
    },
    warning: {
      50: "#fef4e6",
      100: "#fdddb3",
      500: "#ffdf5d",
      800: "#884f05",
      900: "#683c04",
    },
    text: {
      primary: '#231f20',
      secondary: '#545a64',
      disabled: "#636a75",
    },
    textDark: {
      primary: "#edf2f7",
      secondary: "#a0aec0",
      disabled: "rgba(237, 242, 247, 0.35)"
    },
    grey: {
      50: "#f4f5f7",
      100: "#dde1e5",
      200: "#ccd2d8",
      300: "#b5bec7",
      400: "#8d96a0",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#50575e",
      900: "#3d4248"
    },
    background: {
      default: "#F7F7F7",
      paper: "#FFFFFF"
    },
    customGauge: {
      range1: '#0ecb81',
      range2: '#ffdf5d',
      range3: '#884f05',
      range4: '#00b8d9',
      range5: '#ff6e40',
    },
    customColors: {
      pastelGrey: '#CDCDCD',
      loginBackgrounblue: '#2057A6',
      cinder: "#0F131F",
      brownishRed: "#A8382D",
      seaShell: "#F1F1F1",
      lightGreyBlue: "#A6B6D0",
      lavender: "#E6E6E6",
      greyFourty: "#666666",
      codGrey: "#181818",
      cyanBlue: "#3C92DC",
      aumRed: "#FF5630",
      aumOrange: "#FFAB00",
      aumBlue: "#1E90FF",
      aumRedLight: "#FF56301F",
      aumOrangeLight: "#FFAB001F",
      aumBlueLight: '#1E90FF1F',
      brightCerulean: "#00B8D9",
      hyperlinkBlue: "#0072C6",
      riskScoreOrange: "#FF6E40",
      riskScoreRed: "#DD2C00",
      checkBoxUnchecked: "#293139",
      subtitle: '#a33d18',
      blackishGrey90: '#1a1a1a',
      lycanBlue: '#68B7D3',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Global focus-visible outline for ALL focusable elements
        '*:focus-visible': {
          outline: '2px solid #a33d18 !important',
          outlineOffset: '2px',
          borderRadius: '4px',
        },
        // Prevent double outlines on nested focused elements
        '.Mui-focused :focus-visible, .Mui-focused .Mui-focused': {
          outline: 'none !important',
        },
        // Date picker popover - use inset outline to avoid clipping
        '.MuiPickersPopper-root *:focus-visible, .MuiCalendarPicker-root *:focus-visible, .MuiDateCalendar-root *:focus-visible': {
          outlineOffset: '-2px',
        },
        // Ensure reduced motion is respected
        '@media (prefers-reduced-motion: reduce)': {
          '*': {
            animationDuration: '0.01ms !important',
            animationIterationCount: '1 !important',
            transitionDuration: '0.01ms !important',
            scrollBehavior: 'auto !important',
          },
        },
      },
    },
    // Global focus styling for all MUI interactive components (Button, IconButton, Tab, etc.)
    MuiButtonBase: {
      defaultProps: { disableRipple: true },
      styleOverrides: {
        root: {
          '&.Mui-focusVisible, &:focus-visible': {
            outline: '2px solid #a33d18 !important',
            outlineOffset: '2px',
            borderRadius: '4px',
          },
        },
      },
    },
    // Disable focus ripple on individual components for clean focus indication
    MuiIconButton: { defaultProps: { disableFocusRipple: true } },
    MuiTab: { defaultProps: { disableFocusRipple: true } },
    MuiCheckbox: {
      defaultProps: { disableFocusRipple: true },
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #a33d18',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          // Show a proper outline around the entire switch when focused
          '&:has(.Mui-focusVisible)': {
            outline: '2px solid #a33d18 !important',
            outlineOffset: '2px',
            borderRadius: '12px',
          },
          // Suppress the global *:focus-visible on internal elements
          '& *:focus-visible': {
            outline: 'none !important',
          },
        },
        switchBase: {
          '&.Mui-focusVisible': {
            outline: 'none !important',
            backgroundColor: 'transparent',
          },
        },
        input: {
          '&:focus-visible': {
            outline: 'none !important',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible, &:focus-visible': {
            outline: '2px solid #a33d18 !important',
            outlineOffset: '2px',
            borderRadius: '50%',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: { disableFocusRipple: true },
      styleOverrides: {
        root: {
          color: '#FFFFFF ',
          borderRadius: '10px',
          fontWeight: 'bold',
          fontSize: '18px',
          paddingTop: "15px",
          paddingBottom: "15px",
          letterSpacing: "0.36px",
          textTransform: 'none',
          '&:focus-visible': {
            outline: '2px solid #a33d18',
            outlineOffset: '2px',
            boxShadow: '0 0 0 3px rgba(163, 61, 24, 0.2)',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // Highlight the field's own notched border on focus (keeps the label notch intact,
          // so the label is not overshadowed) instead of drawing an outer outline that
          // stacks with the inner input's *:focus-visible outline (double-outline bug).
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#a33d18',
            borderWidth: '2px',
          },
          // Suppress the inner input's own focus-visible outline so only the border highlight shows
          '& .MuiInputBase-input:focus-visible': {
            outline: 'none !important',
          },
        },
        notchedOutline: {
          borderColor: 'rgba(0, 0, 0, 0.23)',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #a33d18',
            outlineOffset: '-2px',
            backgroundColor: 'rgba(163, 61, 24, 0.06)',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          // Suppress the inner select element's own outline so only the field's
          // border highlight (from MuiOutlinedInput.Mui-focused) shows — no extra outline.
          '&:focus-visible': {
            outline: 'none !important',
          },
          '&:focus': {
            outline: 'none !important',
            backgroundColor: 'transparent',
          },
        },
        root: {
          // When inside an InputAdornment (e.g. country-code +91), no focus border on the notch
          '.MuiInputAdornment-root &.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: '2px solid #a33d18',
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {},
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            '&:after': {
              borderBottomColor: '#a33d18',
            },
          },
        },
      },
    },
    MuiSvgIcon: {
      defaultProps: {
        'aria-hidden': 'true' as unknown as boolean,
        focusable: 'false',
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Outfit, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        },
      },
      defaultProps: {
        variantMapping: {
          body_400: 'p',
          body_500: 'p',
          body_600: 'p',
          body_700: 'p',
          subtitle_300: 'p',
          subtitle_400: 'p',
          subtitle_500: 'p',
          subtitle_600: 'p',
          overline_400: 'p',
          overline_600: 'p'
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        scroller: {
          padding: '3px',
          gap: '6px',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        // The "Rows per page" dropdown is a MUI Select whose inner .MuiSelect-select element
        // has focus-visible suppressed by the MuiSelect override above. Re-enable it here so
        // the select gets the same focus ring as the next/previous page buttons.
        select: {
          '&.MuiSelect-select:focus, &.MuiSelect-select:focus-visible': {
            outline: '2px solid #a33d18 !important',
            outlineOffset: '2px',
            borderRadius: '4px',
            backgroundColor: 'transparent',
          },
        },
        // Next / previous page icon buttons — MuiButtonBase already covers Mui-focusVisible,
        // but add an explicit rule here so both elements are visually identical.
        actions: {
          '& button:focus-visible, & button.Mui-focusVisible': {
            outline: '2px solid #a33d18 !important',
            outlineOffset: '2px',
            borderRadius: '4px',
          },
        },
      },
    },
  },
});

export default theme;
